var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"or-divider"},[_c('span',{staticClass:"or-divider-line"}),_vm._v(" "),_c('span',{staticClass:"or-divider-text"},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('span',{staticClass:"or-divider-line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }